var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#404040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctor flow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4333 -13034C-4333 -13035.1 -4332.1 -13036 -4331 -13036H16662C16663.1 -13036 16664 -13035.1 16664 -13034V1170C16664 1171.1 16663.1 1172 16662 1172H-4331C-4332.1 1172 -4333 1171.1 -4333 1170V-13034Z",
    fill: "#807E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4331 -13035H16662V-13037H-4331V-13035ZM16663 -13034V1170H16665V-13034H16663ZM16662 1171H-4331V1173H16662V1171ZM-4332 1170V-13034H-4334V1170H-4332ZM-4331 1171C-4331.55 1171 -4332 1170.55 -4332 1170H-4334C-4334 1171.66 -4332.66 1173 -4331 1173V1171ZM16663 1170C16663 1170.55 16662.6 1171 16662 1171V1173C16663.7 1173 16665 1171.66 16665 1170H16663ZM16662 -13035C16662.6 -13035 16663 -13034.6 16663 -13034H16665C16665 -13035.7 16663.7 -13037 16662 -13037V-13035ZM-4331 -13037C-4332.66 -13037 -4334 -13035.7 -4334 -13034H-4332C-4332 -13034.6 -4331.55 -13035 -4331 -13035V-13037Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 625434"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BLUE BACKGROUND ",
    x: -1379,
    y: -1559,
    width: 1536,
    height: 2007,
    fill: "#E1F3F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 625488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 18227",
    d: "M-1315 -536H81C87.6274 -536 93 -530.627 93 -524V127C93 133.627 87.6274 139 81 139H-1303C-1309.63 139 -1315 133.627 -1315 127V-536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 625345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625197"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 625191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 294029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 258",
    d: "M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z",
    fill: "white",
    stroke: "#19B3B5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon material-edit",
    d: "M9.41406 17.3839V19.8989H11.9876L19.5772 12.482L17.0037 9.96362L9.41406 17.3839ZM21.5671 10.5351C21.6941 10.4091 21.7653 10.2393 21.7653 10.0624C21.7653 9.88555 21.6941 9.71577 21.5671 9.58975L19.9586 8.01789C19.8297 7.89378 19.6559 7.82422 19.475 7.82422C19.294 7.82422 19.1202 7.89378 18.9913 8.01789L17.7378 9.24955L20.3113 11.76L21.5671 10.5351Z",
    fill: "#29BCC1"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPre);
export default __webpack_public_path__ + "static/media/EditPre.e5289f484f8608446f352efba248a58b.svg";
export { ForwardRef as ReactComponent };